import { faMinus, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import "./Increment_Decrement_Btn.css";
import {
  CheckProductInCart,
  getAllCart,
  postCartQuantity,
} from "../../../features/cart/cartSlice";
import { useDispatch, useSelector } from "react-redux";

const IncrementDecrementBtn = (props) => {
  const [cart, setCart] = useState();

  const [Errors, setErrors] = useState();

  const dispatch = useDispatch();
  const cartQuantity = async (type) => {
    setErrors("");
    try {
      const data = {
        cart_id: cart?.id,
        type: type,
        isSignIn: props?.isSignIn,
        product_id: props?.productId,
        variant_id: props?.varientId,
      };
      const res = await dispatch(postCartQuantity({ data: data }));
      if (res.meta?.requestStatus === "fulfilled") {
        await dispatch(getAllCart(props?.isSignIn));
      } else if (res.meta?.requestStatus === "rejected") {
        console.log("Error:", res.payload || "Not In Cart");
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };
  const allCart = useSelector((state) => state.cart.allCarts);

  useEffect(() => {
    // dispatch(
    //   CheckProductInCart({
    //     product_id: props?.productId,
    //     variant_id: props?.varientId,
    //     isSignIn: props?.isSignIn,
    //   })
    // );

    if (props?.cart?.length > 0) {
      for (const item of props.cart) {
        if (item?.variant_id === props.varientId) {
          setCart(item);
        }
      }
    }
    // saveTotal();
  }, [props.cart]);
  // dispatch, allCart, props.cart

  //  useEffect(() => {
  //  setErrors("Out Of Stock")
  // }, [Number(cart?.quantity) >= Number(props.varient?.general_stock)]);

  return (
    <div className="Increment_Decrement_Btn">
      <div className={`main_content_holder`}>
        {/* Decrement Button */}
        <div
          className="icon_holder"
          onClick={() => {
            cartQuantity("minus");
          }}
        >
          {cart?.quantity == 1 ? (
            <FontAwesomeIcon icon={faTrash} className="icon_class" />
          ) : (
            <FontAwesomeIcon icon={faMinus} className="icon_class" />
          )}
        </div>

        <div className="count_holder">
          <p className="count">{cart?.quantity}</p>
        </div>

        <div
          className="icon_holder"
          onClick={() => {
            if (
              Number(cart?.quantity) >= Number(props.varient?.general_stock)
            ) {
              setErrors("Out of Stock");
            } else if (
              props?.product?.allowed_quanitity &&
              Number(cart?.quantity) >= Number(props.product.allowed_quanitity)
            ) {
              setErrors(
                `You can only buy max ${props.product.allowed_quanitity}`
              );
            } else {
              setErrors("");
              cartQuantity("add");
            }
          }}
        >
          <FontAwesomeIcon icon={faPlus} className="icon_class" />
        </div>

        {/* <div
          className="icon_holder"
          onClick={() => {
            cartQuantity("add");
          }}
        >
          <FontAwesomeIcon icon={faPlus} className="icon_class" />
        </div> */}
      </div>
      {Errors && <p style={{ color: "red" }}>{Errors}</p>}
    </div>
  );
};

export default IncrementDecrementBtn;
